module.exports = __webpack_public_path__ + "img/icon_1_4.365b7d8c.png";